import MyCryptoJS from "crypto-js"
// Set your client ID and password
const clientId = process.env.REACT_APP_CLIENT_ID;
const password = process.env.REACT_APP_PASSWORD ;
const APIKey = process.env.REACT_APP_API_KEY
// Generate the timestamp
const utcDateTime = new Date();
const timestamp = utcDateTime.toISOString().replace(/\..+/, ""); // Remove milliseconds
// console.log('TimeStamp is ',timestamp)
// Calculate the seed value (hash)
const seedValue = GetSeedHeader(utcDateTime, clientId, password);
// console.log('Seed value is ',seedValue)
// Set the headers

// Helper function to calculate the hash (same as in the provided code)
function GetSeedHeader(utcdate, clientId, password) {
    const year = utcdate.getUTCFullYear();
    const month = String(utcdate.getUTCMonth() + 1).padStart(2, '0'); // Month is 0-indexed
    const day = String(utcdate.getUTCDate()).padStart(2, '0');
    const hours = String(utcdate.getUTCHours()).padStart(2, '0');
    const minutes = String(utcdate.getUTCMinutes()).padStart(2, '0');
    const seconds = String(utcdate.getUTCSeconds()).padStart(2, '0');
    const date = `${year}-${month}-${day}${hours}${minutes}${seconds}`;
    const data = date + clientId + password;
    // console.log('Data before hashing or seed is: ',data)
    return SHA512(data);
}
// Helper function for SHA512 hashing (same as in the provided code)
function SHA512(input) {
    
    const hash = MyCryptoJS.SHA512(input).toString();
    return hash;
}
export {timestamp, seedValue, clientId,APIKey}